import React from 'react'

export const IconTickOutline = ({
    width,
    height,
    color,
}: {
    width: number
    height: number
    color: string
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5 13L9 17L19 7"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
)
